/**
 * GraphQL Error Codes
 * Centralized error codes shared between backend and frontend
 */
export const ErrorCodes = {
  // General
  UNAUTHENTICATED: "UNAUTHENTICATED",
  FORBIDDEN: "FORBIDDEN",
  BAD_USER_INPUT: "BAD_USER_INPUT",
  BAD_REQUEST: "BAD_REQUEST",
  NOT_FOUND: "NOT_FOUND",
  INTERNAL_SERVER_ERROR: "INTERNAL_SERVER_ERROR",
  NOT_IMPLEMENTED: "NOT_IMPLEMENTED",

  // Trash
  CANNOT_TRASH_ORIGINAL_WITH_LINKED_COPIES: "CANNOT_TRASH_ORIGINAL_WITH_LINKED_COPIES",
  CANNOT_TRASH_WITH_NON_DELETED_CHILD: "CANNOT_TRASH_WITH_NON_DELETED_CHILD",

  // Delete
  CANNOT_DELETE_ORIGINAL_WITH_LINKED_COPIES: "CANNOT_DELETE_ORIGINAL_WITH_LINKED_COPIES",
  CANNOT_DELETE_WITH_ACTIVE_CHILDREN: "CANNOT_DELETE_WITH_ACTIVE_CHILDREN",

  // Move
  CANNOT_MOVE_LINKED_COPY: "CANNOT_MOVE_LINKED_COPY",
  CANNOT_MOVE_INTO_LINKED_COPY: "CANNOT_MOVE_INTO_LINKED_COPY",
  CANNOT_MOVE_INTO_ORIGINAL_WITH_LINKED_COPIES: "CANNOT_MOVE_INTO_ORIGINAL_WITH_LINKED_COPIES",
  MOVE_PROJECT_CREATE_LOOP: "MOVE_PROJECT_CREATE_LOOP",

  // Update
  CANNOT_UPDATE_LINKED_COPY: "CANNOT_UPDATE_LINKED_COPY",

  // Grammar-form publishing
  GRAMMAR_FORM_NOT_PUBLISHABLE: "GRAMMAR_FORM_NOT_PUBLISHABLE",

  // Duplicate
  CANNOT_DUPLICATE_LINKED_COPY: "CANNOT_DUPLICATE_LINKED_COPY",

  // Media
  INVALID_AUDIO: "INVALID_AUDIO",
  // This video can't be auto-captioned (no speech / unreadable audio) — expected, not a failure.
  SUBTITLE_UNAVAILABLE: "SUBTITLE_UNAVAILABLE",

  // The AI provider account is out of credit or over quota — nothing the author can fix.
  AI_CREDITS_EXHAUSTED: "AI_CREDITS_EXHAUSTED",
} as const;

export type ErrorCode = (typeof ErrorCodes)[keyof typeof ErrorCodes];
